export default __webpack_public_path__ + "static/media/background-home.81b5faf5.png";